import Axios from "axios";
import React, { Component } from "react";

export const MyContext = React.createContext();

export default class MyProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: 2,
      authenticated: false,
      session: {},
      windowWidth: window.scrollX,

      setLanguage: langVal => {
        localStorage.setItem('language', langVal);
        this.setState({ language: langVal });
      },

      createSession: user => {
        this.setState({ session: user, authenticated: true });
      },

      login: user => {
        if (user) {
          user.user.password = ""
          this.setState({
            session: user,
            authenticated: true
          });
        }
        // this.gotSession();
      },

      logout: () => {
        Axios.get("/user/logout");
        this.setState({ session: {}, authenticated: false });
      }
    };

    window.addEventListener("resize", this.update);
  }

  update = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentDidMount = () => {
    this.update();
  };

  render() {
    return (
      <MyContext.Provider
        value={{
          state: this.state
        }}
      >
        {this.props.children}
      </MyContext.Provider>
    );
  }
}
